/**
 * PPWD: Color groups: gates the notify-me signup to Signature colors.
 * Docs: dev-notes/color-groups.md
 */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'bis-btn--hidden';

  /**
   *
   * @param {boolean} shouldOffer - true when signup should be available
   * @param {boolean} tightenOnly - true on first paint: only hide, never reveal,
   *   since the server already rendered correct availability
   */
  function renderNotifyMe(shouldOffer, tightenOnly) {
    var trigger = document.querySelector('#klaviyo-bis-button-container');
    if (!trigger) return;

    if (shouldOffer) {
      if (!tightenOnly) trigger.classList.remove(HIDDEN_CLASS);
    } else {
      trigger.classList.add(HIDDEN_CLASS);
    }
  }

  /** Must match the Liquid normalisation in ppwd-color-groups.liquid exactly. */
  function normalize(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .replace(/ /g, '_');
  }

  function readGroups() {
    var blob = document.querySelector('[data-ppwd-color-groups]');
    if (!blob) return null;
    try {
      return JSON.parse(blob.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedColor(groups) {
    if (!groups || !groups.option) return null;
    var inputs = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === groups.option) return inputs[i].value;
    }
    return null;
  }

  /** A product with no groups configured is entirely Signature, so the gate passes. */
  function isSignature() {
    var groups = readGroups();
    if (!groups || !Array.isArray(groups.signature)) return true;
    var current = selectedColor(groups);
    if (current === null) return true;
    return groups.signature.indexOf(normalize(current)) !== -1;
  }

  function update(available, tightenOnly) {
    renderNotifyMe(isSignature() && available === false, tightenOnly === true);
  }

  /** A null variant (impossible option combination) counts as available: nothing to notify about. */
  function availabilityOf(variant) {
    return variant ? variant.available === true : true;
  }

  document.addEventListener('variant:change', function (event) {
    update(availabilityOf(event && event.detail ? event.detail.variant : null));
  });

  // Fires after the picker re-renders, unlike variant:change which fires before the fetch resolves.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      update(availabilityOf(payload && payload.data ? payload.data.variant : null));
    });
  }

  function init() {
    update(false, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
